
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexCYsmL6Luz_45qDWNJvXEcxlSTOjAcyLbvUTHLS8pMoHlkMeta } from "/usr/src/app/apps/frontend/agency/pages/index.vue?macro=true";
import { default as loginrxY1gjpjY6sE997FjG7irnlKudzfyLBV8EHXQy_I6wYMeta } from "/usr/src/app/apps/frontend/agency/pages/login.vue?macro=true";
import { default as indexZk_uTR9UsG15Hd2jh_A7s_cc4sJobcd1f_7FM5oeHrIMeta } from "/usr/src/app/shared/admin-agency/pages/trips/[id]/index.vue?macro=true";
import { default as _91id_93W0nig3tYzAlBor9kBY8eaft3rc6Wt51wIvFvZ3l_AI8Meta } from "/usr/src/app/shared/admin-agency/pages/trips/[id].vue?macro=true";
import { default as indexON0mh4AnEug0e212IXenlmG2keDFHVxDyECVqgnX7qUMeta } from "/usr/src/app/apps/frontend/agency/pages/trips/index.vue?macro=true";
import { default as createP6kgGBcpbcwR8bPqw1Z79YYfAEGZMo4KOwm4aQLhARsMeta } from "/usr/src/app/apps/frontend/agency/pages/trips/create.vue?macro=true";
import { default as TripsEmptyStateLGUFV2zD8BoVqs4JcqDSE8VA_4596CIf0lxOWGqrymO1sMeta } from "/usr/src/app/apps/frontend/agency/pages/trips/_components/TripsEmptyState.vue?macro=true";
import { default as TripAdminActionsb4KyFnMBkKYNWVWY62mbc8KZPF5goqy9z3oGznFkh80Meta } from "/usr/src/app/shared/admin-agency/pages/trips/_components/TripAdminActions.vue?macro=true";
import { default as TripAgencyActionsb95f47Fi5YWDpK3KuRlWhtyOwyceCpvCWXbN8_45hcuGsMeta } from "/usr/src/app/shared/admin-agency/pages/trips/_components/TripAgencyActions.vue?macro=true";
import { default as tripsMroy1tjWSLBY9v_455rNRHnuvnCzMQqGzL91zHPz2UYb4Meta } from "/usr/src/app/shared/admin-agency/pages/trips.vue?macro=true";
import { default as indexm1vrj__45hY7Jrhm2mMgLkLxLEeqLij1E2j0zgd2UrfawMeta } from "/usr/src/app/apps/frontend/agency/pages/configurations/tabs/index.vue?macro=true";
import { default as usersmVWq7Ik7UNfXA_45XQ_EPXA_451frwKgcMQUCW3UHDYLq1oMeta } from "/usr/src/app/apps/frontend/agency/pages/configurations/tabs/users.vue?macro=true";
import { default as account0OUQVoL8dlFtvfo7Ei0ZSXcneNZTvw77roz2_453_45iUq0Meta } from "/usr/src/app/apps/frontend/agency/pages/configurations/tabs/account.vue?macro=true";
import { default as tabsDL4iOwKqd4Pq9zBN6ygrNkHSZL4kLG4sb3ylhbJs950Meta } from "/usr/src/app/apps/frontend/agency/pages/configurations/tabs.vue?macro=true";
import { default as configurationspRLrTnTsb6GL4gHZ6xl_45G8mN3rj0DC1TXPRfNUV9VsEMeta } from "/usr/src/app/apps/frontend/agency/pages/configurations.vue?macro=true";
import { default as _91id_93CCiVYieV6C4haO_45lUcWiKwjTafoh2LLc8qG6JGcxOpIMeta } from "/usr/src/app/apps/frontend/agency/pages/proposals/[id].vue?macro=true";
import { default as indexnrzM3RbyVo6ajtVq87nqnC2k_fi5pgaCPQOJwtInfRwMeta } from "/usr/src/app/apps/frontend/agency/pages/register/index.vue?macro=true";
import { default as indexNXMXfEZu179IiDP0rj9EBjfnbjShNDH28rtAUrxxHTMMeta } from "/usr/src/app/apps/frontend/agency/pages/proposals/index.vue?macro=true";
import { default as indexLUsjIaKbBs6F0m2niQ5Id0e34ZmqgM_45ROS7C0VBPqp4Meta } from "/usr/src/app/apps/frontend/agency/pages/subscription/tabs/index.vue?macro=true";
import { default as invoicesgLNVd3TDOSMW80hdJ728CNluNzxPm4IMgCfGTqKYHBwMeta } from "/usr/src/app/apps/frontend/agency/pages/subscription/tabs/invoices.vue?macro=true";
import { default as tabslLujk9uN8tlQSlM98xr8PKlCGVIB1hkOTwBEMrwBlzAMeta } from "/usr/src/app/apps/frontend/agency/pages/subscription/tabs.vue?macro=true";
import { default as successgU_AyCLJZV2JnUKIDjSdEKWy6zq9JlXdoKPN78HcwZYMeta } from "/usr/src/app/apps/frontend/agency/pages/subscription/success.vue?macro=true";
import { default as indexubfLxFhfuA_45R3YrskORKWlS_kh1dhZtyR10F6ZHH054Meta } from "/usr/src/app/apps/frontend/agency/pages/payment/[token]/index.vue?macro=true";
import { default as success_45guestJMKjh1p7p2NEK0rt8KR_45v5iIGTb6bva0nfVD0KPI_450IMeta } from "/usr/src/app/apps/frontend/agency/pages/payment/success-guest.vue?macro=true";
import { default as confirmationLuVYxFFAfXYaCtH42x1cj0YBueyr2zaX0HTkLga4BC0Meta } from "/usr/src/app/apps/frontend/agency/pages/register/confirmation.vue?macro=true";
import { default as _91provider_93oGVZqOwj_45g70eQ_45pyyix1iKFuAGxza6BHHSfProgKiMMeta } from "/usr/src/app/shared/common/pages/auth/callback/[provider].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginrxY1gjpjY6sE997FjG7irnlKudzfyLBV8EHXQy_I6wYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/login.vue")
  },
  {
    name: tripsMroy1tjWSLBY9v_455rNRHnuvnCzMQqGzL91zHPz2UYb4Meta?.name,
    path: "/trips",
    meta: tripsMroy1tjWSLBY9v_455rNRHnuvnCzMQqGzL91zHPz2UYb4Meta || {},
    component: () => import("/usr/src/app/shared/admin-agency/pages/trips.vue"),
    children: [
  {
    name: _91id_93W0nig3tYzAlBor9kBY8eaft3rc6Wt51wIvFvZ3l_AI8Meta?.name,
    path: ":id()",
    component: () => import("/usr/src/app/shared/admin-agency/pages/trips/[id].vue"),
    children: [
  {
    name: "trips-id",
    path: "",
    component: () => import("/usr/src/app/shared/admin-agency/pages/trips/[id]/index.vue")
  }
]
  },
  {
    name: "trips",
    path: "",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/trips/index.vue")
  },
  {
    name: "trips-create",
    path: "/trips/add",
    meta: createP6kgGBcpbcwR8bPqw1Z79YYfAEGZMo4KOwm4aQLhARsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/trips/create.vue")
  },
  {
    name: "trips-_components-TripsEmptyState",
    path: "_components/TripsEmptyState",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/trips/_components/TripsEmptyState.vue")
  },
  {
    name: "trips-_components-TripAdminActions",
    path: "_components/TripAdminActions",
    component: () => import("/usr/src/app/shared/admin-agency/pages/trips/_components/TripAdminActions.vue")
  },
  {
    name: "trips-_components-TripAgencyActions",
    path: "_components/TripAgencyActions",
    component: () => import("/usr/src/app/shared/admin-agency/pages/trips/_components/TripAgencyActions.vue")
  }
]
  },
  {
    name: "configurations",
    path: "/configurations",
    meta: configurationspRLrTnTsb6GL4gHZ6xl_45G8mN3rj0DC1TXPRfNUV9VsEMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/configurations.vue"),
    children: [
  {
    name: tabsDL4iOwKqd4Pq9zBN6ygrNkHSZL4kLG4sb3ylhbJs950Meta?.name,
    path: "/configuration",
    meta: tabsDL4iOwKqd4Pq9zBN6ygrNkHSZL4kLG4sb3ylhbJs950Meta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/configurations/tabs.vue"),
    children: [
  {
    name: "configurations-tabs",
    path: "",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/configurations/tabs/index.vue")
  },
  {
    name: "configurations-tabs-users",
    path: "users",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/configurations/tabs/users.vue")
  },
  {
    name: "configurations-tabs-account",
    path: "account",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/configurations/tabs/account.vue")
  }
]
  }
]
  },
  {
    name: "proposals-id",
    path: "/travels/:id",
    meta: _91id_93CCiVYieV6C4haO_45lUcWiKwjTafoh2LLc8qG6JGcxOpIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/proposals/[id].vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexnrzM3RbyVo6ajtVq87nqnC2k_fi5pgaCPQOJwtInfRwMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/register/index.vue")
  },
  {
    name: "proposals",
    path: "/proposals",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/proposals/index.vue")
  },
  {
    name: tabslLujk9uN8tlQSlM98xr8PKlCGVIB1hkOTwBEMrwBlzAMeta?.name,
    path: "/subscription",
    meta: tabslLujk9uN8tlQSlM98xr8PKlCGVIB1hkOTwBEMrwBlzAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/subscription/tabs.vue"),
    children: [
  {
    name: "subscription-tabs",
    path: "",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/subscription/tabs/index.vue")
  },
  {
    name: "subscription-tabs-invoices",
    path: "/subscription/invoices",
    meta: invoicesgLNVd3TDOSMW80hdJ728CNluNzxPm4IMgCfGTqKYHBwMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/subscription/tabs/invoices.vue")
  }
]
  },
  {
    name: "subscription-success",
    path: "/subscription/success",
    component: () => import("/usr/src/app/apps/frontend/agency/pages/subscription/success.vue")
  },
  {
    name: "payment-token",
    path: "/payment/:token()",
    meta: indexubfLxFhfuA_45R3YrskORKWlS_kh1dhZtyR10F6ZHH054Meta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/payment/[token]/index.vue")
  },
  {
    name: "payment-success-guest",
    path: "/payment/success-guest",
    meta: success_45guestJMKjh1p7p2NEK0rt8KR_45v5iIGTb6bva0nfVD0KPI_450IMeta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/payment/success-guest.vue")
  },
  {
    name: "register-confirmation",
    path: "/register/confirmation",
    meta: confirmationLuVYxFFAfXYaCtH42x1cj0YBueyr2zaX0HTkLga4BC0Meta || {},
    component: () => import("/usr/src/app/apps/frontend/agency/pages/register/confirmation.vue")
  },
  {
    name: "auth-callback-provider",
    path: "/auth/callback/:provider()",
    meta: _91provider_93oGVZqOwj_45g70eQ_45pyyix1iKFuAGxza6BHHSfProgKiMMeta || {},
    component: () => import("/usr/src/app/shared/common/pages/auth/callback/[provider].vue")
  }
]